/**
 * PA hook — practitioner-scoped practice list.
 *
 * GET /api/v1/Practice/ForPractitioner/{doctorSetupId}
 *
 * Ported from PM's use-practitioner-practices.ts (Scripsteam/dev-scrips-pm-react).
 * Filtered server-side to the practices this practitioner is assigned to.
 * Flutter source: settings_data_source_impl.dart:477 (doctorPracticeList).
 *
 * URL prefix note: /api/v1/Practice/... (NOT /api/Practice/...).
 * Practice_v1 vs Practice are different .NET controllers — do not normalise.
 */
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { PracticeListItem } from '@/types/practice-api';

export function usePractitionerPractices(
  doctorSetupId: string | null | undefined,
) {
  return useQuery({
    queryKey: ['pa-practitioner-practices', doctorSetupId],
    queryFn: ({ signal }) => {
      if (!doctorSetupId) {
        throw new Error('usePractitionerPractices called without doctorSetupId');
      }
      return get<PracticeListItem[]>(
        `/api/v1/Practice/ForPractitioner/${doctorSetupId}`,
        { signal },
      );
    },
    enabled: !!doctorSetupId,
  });
}
